// AI Generated Test
import { Component, Input, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormGlobalPolicyDialogSaveComponent } from '@client/app/forms/global-policy/dialogs/save/save.component';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonModalService } from 'app/modules/modals/services/mon-modal/mon-modal.service';
import { NgbModalOpenerService } from '@client/app/services/ngb-modal-opener/ngb-modal-opener.service';
import { SmartScrollService } from '@client/app/plugins/scroll/smart-scroll.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { NgForm } from '@angular/forms';
import {
    FormGlobalPolicyPreContentComponent,
} from '@client/app/forms/global-policy/steps/pre-content/form-global-policy-pre-content.component';
import { asyncExecute } from '@client/app/core/utils/async-execute';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy',
    standalone: false,
    template: `
        <div class="global-policy-form">
            <form #policyForm="ngForm" class="form-horizontal" (ngSubmit)="policyForm.valid && submit()">
                <div class="mon-dialog-header">
                    <div class="row">
                        <div class="col-48 outer-t-smurf">
                            <page-header [header]="('Edit Policy' | translate) + ': ' + policy.name"
                                         [trustAsHtml]="false"
                                         [panelClass]="'row'"
                                         [panelLeftClass]="'col-48 mt-1'"
                                         *ngIf="policy.id">
                            </page-header>
                            <page-header [header]="'New Policy' | translate"
                                         [trustAsHtml]="false"
                                         [panelClass]="'row'"
                                         [panelLeftClass]="'col-48 mt-1'"
                                         *ngIf="!policy.id">
                            </page-header>
                        </div>
                    </div>
                </div>
                <div class="bg-light-grey auto-scroll"
                    id="policyModalScrollable"
                    [ngClass]="{'mon-dialog-body-with-footer': getStep() !== 'policyContent', 'mon-dialog-body': getStep() === 'policyContent'}">
                    <form-global-policy-exchange-center *ngIf="!policy.id && step === -1"
                                                        (chooseTemplate)="chooseTemplate($event.template)">
                    </form-global-policy-exchange-center>
                    <form-global-policy-content *ngIf="getStep() === 'policyContent'"
                                                (wizNext)="wizNext()"
                                                [policy]="policy">
                    </form-global-policy-content>
                    <mon-spinner [loading]="loading" *ngIf="getStep() === 'policyRules'">
                        <form-global-policy-rules [boxTab]="boxTab"
                                                  [policy]="policy"
                                                  [containerForm]="policyForm">
                        </form-global-policy-rules>
                    </mon-spinner>
                </div>
                <div class="mon-dialog-footer" *ngIf="step >= 0">
                    <div class="row" *ngIf="!loading">
                        <div class="col-48 text-right">
                            <ng-container *ngIf="!firstStep && !createdByAi">
                                <button type="button"
                                        data-test="previous-button"
                                        monEventTrigger="actionTrigger"
                                        class="btn btn-border-radius btn-secondary"
                                        (click)="wizPrev()">
                                    <span class="fas fa-arrow-left"></span>&nbsp;
                                    <span translate>Previous</span>
                                </button>
                            </ng-container>
                            <button type="button"
                                    data-test="next-button"
                                    monEventTrigger="actionTrigger"
                                    [disabled]="policyForm.form.get(getStep())?.invalid"
                                    *ngIf="!lastStep"
                                    class="btn btn-border-radius btn-secondary outer-l-mini"
                                    (click)="wizNext()"
                                    translate
                            >
                                Next
                            </button>
                            <button type="submit"
                                    data-test="save-button"
                                    monEventTrigger="actionTrigger"
                                    [disabled]="policyForm?.invalid"
                                    *ngIf="lastStep && policy.rules && policy.rules.length > 0"
                                    class="btn btn-border-radius emphasised-btn outer-l-mini"
                            >
                                <span translate>Save</span>
                            </button>

                            <button [type]="'button'"
                                    *ngIf="lastStep && policy.rules && (policy.rules.length === 0 && boxTab !== 'rule')"
                                    (click)="boxTab = 'rule'"
                                    [attr.class]="'btn btn-border-radius btn-secondary outer-l-mini'"
                            >
                                <span data-test="add-rule-button_save" class="fas fa-plus-square fa-lg"></span>
                                <span translate>Add rule to the policy</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    `,
})
export class FormGlobalPolicyComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() policy: any = {};
    @Input() monDialogId: string = '';
    @Input() setForm: any;
    @Input() createdByAi: boolean = false;

    formSteps: any;
    listenScrollToDropzone: any;
    loading: boolean = false;
    step: number = 0;
    firstStep: boolean = true;
    lastStep: boolean = false;
    boxTab: string = '';
    @ViewChild('policyForm') policyForm?: NgForm;

    constructor (
        private monDialog: MonDialog,
        private translateService: TranslateService,
        private monModalService: MonModalService,
        private monEventsService: MonEventService,
        private smartScroll: SmartScrollService,
        private ngbModalOpenerService: NgbModalOpenerService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setForm(this.monDialogId, this.policyForm);
    }

    ngOnDestroy () {
        this.onDestroy();
    }

    activate () {
        this.loading = true;
        this.createdByAi = this.createdByAi || false;
        if (this.policy && this.policy.subject) {
            this.formSteps = ['policyRules'];
        } else {
            this.policy = this.policy || {};
            this.formSteps = ['policyContent', 'policyRules'];
        }

        if (Object.keys(this.policy).length === 0) {
            this.step = -1;
        } else {
            if (this.policy.subject && this.policy.subject.length > 0) {
                this.step = this.formSteps.indexOf('policyRules');
            } else {
                this.step = 0;
            }
        }

        this.firstStep = true;
        this.lastStep = this.formSteps.length === 1;

        this.listenScrollToDropzone = this.monEventsService.addListener('scrollToDropzone' as any, () => {
            const element = document.getElementById('policyModalScrollable');
            if (element) {
                this.smartScroll.scrollTo(element, 'scrollToPolicyBottom', 250);
            }
        });

        this.loading = false;
    }

    onDestroy () {
        this.monEventsService.remove(this.listenScrollToDropzone);
    }

    chooseTemplate (template: any) {
        this.policy = Object.assign({}, this.policy, template.policy);
        const step = this.policy.subject ? 'policyRules' : 'policyContent';

        if (template.pre_content_component !== undefined) {
            const dialogParams = {
                body: FormGlobalPolicyPreContentComponent,
                data: { template: template },
                size: 'lg',
            };

            const callback = (result: any) => {
                if (result) {
                    this.policy.rules = result;
                    this.goTo(step);
                }
            };
            this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params: dialogParams, callback });
        } else {
            this.goTo(step);
        }
    }

    async submit () {
        const policy = safeClone(this.policy);
        policy.labels = policy.labels || [];
        policy.target_all_domains = policy.target_all_domains === 'true';
        if (policy.target_all_domains) {
            policy.targets = [];
        }
        policy.labels = policy.labels.map((label: any) => {
            return label.id;
        });

        const [checkTargetsError, checkTargetsResult] = await asyncExecute(this.checkTargets(policy));
        if (checkTargetsError || (checkTargetsResult === null)) {
            return;
        }

        // HACK: Timeout added because the previous modal (if exists) is still closing, which somehow causing conflicts and break the app
        await new Promise(resolve => setTimeout(resolve, 500));

        await this.openSaveDialog(policy);
    }

    async checkTargets (policy: any): Promise<string> {
        if (!policy.targets || (policy.targets.length === 0 && !policy.target_all_domains)) {
            const msg = this.translateService.getString('There are no domains assigned to this policy. Save policy anyway?');
            return this.monModalService.confirm(msg);
        }
        return '';
    }

    async openSaveDialog (policy: any): Promise<void> {
        const [rejected, savedPolicy] = await asyncExecute(this.ngbModalOpenerService
            .open({
                component: FormGlobalPolicyDialogSaveComponent,
                resolve: {
                    policy,
                },
            })
            .result);
        if (rejected) {
            return;
        }

        if (savedPolicy) {
            FormUtils.markFormAsPristine(this.policyForm);
            this.close(savedPolicy);
        }
    }

    getStep () {
        return this.formSteps[this.step] || false;
    }

    close (savedPolicy: any) {
        this.monDialog.close(this.monDialogId, savedPolicy || this.policy);
    }

    wizPrev () {
        this.step = this.step <= -1 ? 0 : this.step - 1;
        if (this.step === -1) {
            this.policy = { rules: [] };
        }
        this.checkSteps();
    }

    wizNext () {
        this.step = this.step + 1 >= this.formSteps.length ? this.step : this.step + 1;
        this.checkSteps();
    }

    goTo (stepName: string) {
        this.step = this.formSteps.indexOf(stepName);
        this.checkSteps();
    }

    checkSteps () {
        this.firstStep = this.step === -1;
        this.lastStep = this.formSteps.length - 1 === this.step;
    }
}
